export default __webpack_public_path__ + "images/4W.27b6cba.png";